import axiosInstance from "../axiosInterceptor";

export async function getSettings() {
    const response = await axiosInstance.get(`/admin/setting/getSetting`);
    const data = response?.data;
    return data;
}
